import axios from 'axios';
import api from '@modules/api/index';
import { useMutation } from 'react-query';
import { ApiResponse } from '@modules/types/api';

export const getFAQList = async (): Promise<
    ApiResponse<{
        categoryList: { ko: string[]; en: string[] };
        data: { id: number; category: string; question: string; answer: string }[];
    }>
> => {
    return axios.get(
        `${
            process.env.NEXT_PUBLIC_NODE_ENV === 'development'
                ? process.env.NEXT_PUBLIC_API_URL_DEV
                : process.env.NEXT_PUBLIC_API_URL
        }/faq`,
    );
};

const incrementView = async (id: number) => {
    const { data } = await api.patch(`/faq/${id}/view`);
    return data;
};

export const incrementViewAPI = () => {
    return useMutation((id: number) => incrementView(id));
};
